import { Button, Card, Modal } from "flowbite-react";
import { HiTrash } from "react-icons/hi";
import { useEffect, useState } from "react";
import FileList from "./FileList";
import { Attachment } from "../types/attachment";
import { toast } from 'react-toastify';
import useSlideshow from "../hooks/useSlideshow";

interface Props {
    open: boolean;
    slideshowId?: number;
    onClose: () => void;
    onSave: (slideshowId: number) => void;
    onDelete: (slideshowId: number) => void;
}

const SlideshowManager = (props: Props) => {
    const { fetchSlideshow, saveSlideshow, loading, deleteSlideshow } = useSlideshow();

    const [files, setFiles] = useState<Array<Attachment>>([])

    const updateFiles = (file: Attachment) => setFiles([...files, file])

    const deleteFile = (fileId: number) => setFiles(files.filter(file => file.id !== fileId))

    const onDelete = async () => {
        if(!props.slideshowId || props.slideshowId === 0) return
        const confirm = window.confirm("¿Está seguro que desea eliminar este slideshow?")
        if(!confirm) return

        await deleteSlideshow(props.slideshowId!)
        props.onDelete(props.slideshowId!)
    }

    const onSave = async () => {
        if(files.length === 0) {
            toast("Por favor seleccione una o más imágenes",{
                type:"error"
            })
            return
        }

        const propsSlideshowId = props.slideshowId ?? undefined
        const slideshowId = await saveSlideshow(propsSlideshowId, files)
        toast(slideshowId ? "Slideshow guardado correctamente." : "Ocurrió un error al guardar el slideshow",{
            type: slideshowId ? "success" : "error"
        })

        if(slideshowId === 0) return
        props.onSave(slideshowId)
    }

    const initializeSlideshow = async () => {
        if(!props.slideshowId) return
        const files = await fetchSlideshow(props.slideshowId)
        setFiles(files)
    }

    useEffect(() => {
        initializeSlideshow()
        // eslint-disable-next-line
    },[props.slideshowId])

    const renderSelectedFiles = () => {
        if(files.length === 0) return <span>Seleccione una o más imágenes</span>
        return <div className="flex-row flex items-start justify-start gap-4 flex-wrap">
            {files.map((file) => <Card 
                key={file.id}
                className="min-w-32"
                imgSrc={`${process.env.REACT_APP_UPLOADS}/${file.url}`}
            >
                <Button color="gray" onClick={() => deleteFile(file.id)}>
                    <HiTrash />
                </Button>
            </Card>)}
        </div>
    }

    return <Modal size="7xl" show={props.open} onClose={() => {
        if(!loading) {
            props.onClose()
            return
        }
    }}>
        <Modal.Header>Slideshow</Modal.Header>
        <Modal.Body>
            <div className="flex flex-row">
                <div className="flex flex-2 min-w-80 max-w-80 h-96 overflow-y-scroll">{renderSelectedFiles()}</div>
                <div className="flex flex-1 h-96 overflow-y-scroll flex-col">
                    <FileList type="image" page={1} onSelect={(file) => updateFiles(file)} />
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={props.onClose} color="gray" disabled={loading}>{loading ? '...' : 'Cancelar'}</Button>
            <Button onClick={onSave} color="success" disabled={loading}>{loading ? 'Espere ...' : 'Guardar'}</Button>
            {props.slideshowId !== undefined  && props.slideshowId > 0 && <Button onClick={onDelete} color="failure" disabled={loading}>{loading ? 'Espere ...' : 'Eliminar'}</Button>}
        </Modal.Footer>
    </Modal>
}

export default SlideshowManager